import { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { useMenu } from '@/hooks/useMenu'
import { useAction } from '@/hooks/useAction'
import CustomView from '@/components/CustomView'

import { IMenuItem } from '..'
import { ItemWrapper } from '../Menu.styles'
import { Item } from './Item.styles'

function MenuItem({ ...props }: IMenuItem) {
  const { SET_ACTION_NAME, updateValue: updateActionContext } = useAction()
  const [active, setActive] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const { updateValue, toggle } = useMenu()

  function getActiveLink() {
    const path = `/${location.pathname.split('/')[1]}`
    const parametrizationPath = path.includes('parametrizacao')
      ? path.split('-')[0]
      : ''

    if (path === props.redirect || parametrizationPath === props.redirect) {
      setActive(true)
      return
    }
    setActive(false)
  }

  const handleClickLink = () => {
    const redirect = props?.redirect
    const current = `${location.pathname}${location.search}`
    if (current === redirect && redirect)
      navigate(0)

    clearActionContext()
  }

  const clearActionContext = () => {
    SET_ACTION_NAME('')
    updateActionContext('')
  }

  useEffect(() => {
    getActiveLink()
  }, [location])

  function setItems() {
    if (props.isToggleButton) {
      return <Item {...props} bgcolor="red" />
    }

    if (props.subcategory && props.subcategory.length >= 1) {
      return (
        <CustomView onClick={toggle ? updateValue : () => { }}>
          <Item {...props} active={active} />
        </CustomView>
      )
    }

    return (
      <Link
        style={{ textDecoration: 'none', color: 'unset' }}
        onClick={handleClickLink}
        to={props?.redirect ?? window.location.pathname}
      >
        <Item {...props} />
      </Link>
    )
  }

  return (
    <ItemWrapper className={active ? 'active' : ''}>{setItems()}</ItemWrapper>
  )
}
export default MenuItem
